import { clickOutside } from '@/shared/helpers/helpers';

export class HeaderSearch {
	fieldSelector = '.header-search__field';
	resultSelector = '.header-search__result';
	clearResultSelector = '.js-search__clear-result';
	mobileSearchButtonSelector = '.header-main__button--search';
	visibleSearchClass = 'header-search--visible';
	hiddenResultClass = 'header-search__result--hidden';

	constructor(element) {
		if (!element) return;
		this.container = element;

		this.init();
	}

	init() {
		this.field = this.container.querySelector(this.fieldSelector);
		this.result = this.container.querySelector(this.resultSelector);
		if (!this.field || !this.result) return;

		this.clearResultButton = this.container.querySelector(this.clearResultSelector);
		this.mobileSearchButton = document.querySelector(this.mobileSearchButtonSelector);

		this.bindEvents();
	}

	handleFocus = () => {
		this.result.classList.remove(this.hiddenResultClass);
		window.app.modal.close();
	};

	handleDocumentClick = (e) => {
		const isHidden = this.result.classList.contains(this.hiddenResultClass);
		const fieldHasFocus = document.activeElement === this.field;
		if (fieldHasFocus) return;

		if (!isHidden && clickOutside(e, this.result) && clickOutside(e, this.field) && clickOutside(e, this.clearResultButton)) {
			this.container.classList.remove(this.visibleSearchClass);
			this.result.classList.add(this.hiddenResultClass);
		}
	};

	onMobileSearchTransitionEnd = () => {
		this.field.focus();
		this.container.removeEventListener('transitionend', this.onMobileSearchTransitionEnd);
	};

	handleMobileSearchButtonClick = (e) => {
		e.preventDefault();
		e.currentTarget.blur();
		this.container.classList.toggle(this.visibleSearchClass);

		this.container.addEventListener('transitionend', this.onMobileSearchTransitionEnd);
	};

	handleClearHistoryEvent = () => {
		this.container.classList.remove(this.visibleSearchClass);
		this.result.classList.add(this.hiddenResultClass);
	};

	bindEvents() {
		this.field.addEventListener('focus', this.handleFocus);
		document.addEventListener('click', this.handleDocumentClick);
		this.mobileSearchButton.addEventListener('click', this.handleMobileSearchButtonClick);
		this.container.addEventListener('search:clearHistory', this.handleClearHistoryEvent);
	}
}
